import { render, staticRenderFns } from "./EditorSideBar.vue?vue&type=template&id=4225a71e"
import script from "./EditorSideBar.vue?vue&type=script&lang=ts"
export * from "./EditorSideBar.vue?vue&type=script&lang=ts"
import style0 from "./EditorSideBar.vue?vue&type=style&index=0&id=4225a71e&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports